import { PageResponse } from '@core/entities/pagination'
import {
  useInfiniteQuery,
  UseInfiniteQueryOptions,
} from '@tanstack/react-query'
import { tasksKeys, RequestTypes } from '@core/react-query/features/tasks/tasks'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { usePageableQuery } from '@core/react-query/hooks'
import {
  ITaskPaginated,
  TaskPaginated,
} from '@core/entities/task/TaskPaginated'

const dataTransformer = ({ content }: PageResponse<ITaskPaginated>) => {
  return content.map((task) => TaskPaginated.new(task))
}

export const useGetMyTasksInfinityQuery = (
  payload: RequestTypes['getMyTasks'],
  options: UseInfiniteQueryOptions<
    PageResponse<ITaskPaginated>,
    RequestErrorType,
    Array<TaskPaginated>
  >,
) => {
  const myTasksQuery = tasksKeys.myTasks(payload)
  const infiniteQueryOptions = usePageableQuery({
    queryEnabled: options.enabled,
    queryKey: myTasksQuery.queryKey,
    dataTransformer,
  })

  return useInfiniteQuery<
    PageResponse<ITaskPaginated>,
    RequestErrorType,
    Array<TaskPaginated>
  >({
    ...infiniteQueryOptions,
    ...myTasksQuery,
    ...options,
  })
}
